import { Box } from '@mui/material';

import { styled } from '@mui/material/styles';

// eslint-disable-next-line import/prefer-default-export
export const DesktopFilterWrapper = styled(Box)({
  display: 'flex',
  height: '100%',
  position: 'fixed',
  top: 48,
});

export const MobileFilterDrawer = styled(Box)(({ theme }) => ({
  width: '80vw',
  [theme.breakpoints.up('sm')]: {
    maxWidth: 325,
  },
}));

export const NoResultsDiv = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.light,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  justifyContent: 'center',
  minHeight: 300,
  width: '100%',
  [theme.breakpoints.only('sm')]: {
    marginLeft: -24,
  },
  [theme.breakpoints.only('xs')]: {
    marginLeft: -12,
  },
}));

export const SearchPtoSection = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.surface.light,
  display: 'flex',
  width: '100%',
}));

export const SearchResults = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 2, 9),
  minHeight: 300,
  [theme.breakpoints.up('lg')]: {
    minHeight: '100vh',
    paddingTop: theme.spacing(16.5),
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '100vh',
    paddingTop: theme.spacing(17),
  },
}));

export const SearchResultsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'flex-start',
  width: '100%',
  [theme.breakpoints.between('md', '1200')]: {
    padding: theme.spacing(18, 0, 0),
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 3, 0, 37.5),
  },
}));

export const TooManyResultsDiv = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.light,
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3),
}));
